// Pure helpers for the "your leave is taking too long" overlay. Kept out of the route
// component so they're unit-testable in the node test env (no DOM).

// A healthy drain ends on its last leg's :DOWN, which takes seconds. Past this the
// leave is clearly abnormal — the core protects any leg still in flight all the way to
// its 30-minute ceiling, so the SDR would otherwise sit behind a spinner until then.
//
// Deliberately the core's `leaving_reap_ms` (2 min): that tick is where the reaper first
// finds a leg still in flight and declares the drain held rather than purging it. Raising
// this only delays the escape; lowering it offers a way out of drains the core has not
// yet judged stalled.
export const LEAVE_STALLED_MS = 120_000;

// Measured from the CLICK, not from the core's reply, so a leave whose reply never
// arrives at all is covered too.
export function leaveStalled(leavingSince: number | null, now: number): boolean {
  if (leavingSince === null) return false;
  return now - leavingSince >= LEAVE_STALLED_MS;
}

// Coarse "3 minutes" / "45 seconds" — this is a "something is wrong" signal, not a
// stopwatch. A null/future stamp reads as "a moment" rather than a negative duration.
export function formatWaitedFor(leavingSince: number | null, now: number): string {
  if (leavingSince === null) return 'a moment';
  const ms = now - leavingSince;
  if (!Number.isFinite(ms) || ms <= 0) return 'a moment';
  const seconds = Math.round(ms / 1000);
  if (seconds < 60) return `${seconds} seconds`;
  const minutes = Math.round(seconds / 60);
  return minutes === 1 ? '1 minute' : `${minutes} minutes`;
}
